<template>
  <a-popover
          v-model="visible"
          trigger="click"
          placement="bottomRight"
          overlayClassName="header-notice-wrapper"
          :autoAdjustOverflow="true"
          :arrowPointAtCenter="true"
          :overlayStyle="{ width: '300px', top: '50px' }"
  >
    <template slot="content">
      <a-spin :spinning="loadding">
        <a-tabs>
          <a-tab-pane tab="通知" key="1">
            <a-list>
              <a-list-item v-for="(item,key) in list" :key="key" style="cursor: pointer">
                <a-list-item-meta @click="jump(item.url)" :title="item.title" :description="item.desc">
                  <a-avatar style="background-color: white" slot="avatar" src="https://gw.alipayobjects.com/zos/rmsportal/ThXAXghbEsBCCSDihZxY.png"/>
                </a-list-item-meta>
              </a-list-item>
              <!--<a-list-item>-->
              <!--<a-list-item-meta title="你推荐的 曲妮妮 已通过第三轮面试" description="1天前">-->
              <!--<a-avatar style="background-color: white" slot="avatar" src="https://gw.alipayobjects.com/zos/rmsportal/OKJXDXrmkNshAMvwtvhu.png"/>-->
              <!--</a-list-item-meta>-->
              <!--</a-list-item>-->
              <!--<a-list-item>-->
              <!--<a-list-item-meta title="这种模板可以区分多种通知类型" description="1天前">-->
              <!--<a-avatar style="background-color: white" slot="avatar" src="https://gw.alipayobjects.com/zos/rmsportal/kISTdvpyTAhtGxpovNWd.png"/>-->
              <!--</a-list-item-meta>-->
              <!--</a-list-item>-->
            </a-list>
          </a-tab-pane>

          <!--<a-tab-pane tab="消息" key="2">-->
          <!--123-->
          <!--</a-tab-pane>-->
          <!--<a-tab-pane tab="待办" key="3">-->
          <!--123-->
          <!--</a-tab-pane>-->

        </a-tabs>
      </a-spin>
    </template>
    <span @click="visible = !visible" class="header-notice">
      <a-badge :count="count">
        <a-icon style="font-size: 16px; padding: 4px" type="bell" />
      </a-badge>
    </span>
  </a-popover>
</template>

<script>
  import { noticeData  } from '@/api/analysis'

  export default {
    name: 'HeaderNotice',
    data () {
      return {
        loadding: false,
        visible: false,
        count:0,
        list:[
        ]
      }
    },
    created (){
      this.fetchNotice();
    },
    methods: {
      jump(url){
        console.log(url)
        this.$router.push(url);
      },
      fetchNotice () {

        let that = this;
        noticeData().then(res =>{
          that.count = res.data.count;
          that.list =res.data.list;
        },res =>{
        })

      }
    }
  }
</script>

<style lang="css">
  .header-notice-wrapper {
    top: 50px !important;
  }
</style>
<style lang="less" scoped>
  .header-notice{
    display: inline-block;
    transition: all 0.3s;

    span {
      vertical-align: initial;
    }
  }
</style>
